/**
 * The "New studio" dialog's device fields for a template: the simulators'
 * host and port block, or vMix's host and TCP API port (docs/vmix.md). Each
 * field marks itself invalid as `lib/studio/templateTarget.ts` would refuse it.
 */
import { DEFAULT_VMIX_PORT } from '@acp/engine/templates.js';
import { basePortOf, tcpPortOf } from '../../lib/studio/templateTarget.js';
import { Field, FieldDescription } from '../ui/field.js';
import { Input } from '../ui/input.js';
import { Label } from '../ui/label.js';

export function SimFields({ host, basePort, pending, onHost, onBasePort }: { readonly host: string; readonly basePort: string; readonly pending: boolean; readonly onHost: (v: string) => void; readonly onBasePort: (v: string) => void }) {
  const port = basePortOf(basePort);
  return (
    <div className="grid grid-cols-2 gap-3">
      <Field>
        <Label htmlFor="studio-sim-host">Simulator host</Label>
        <Input id="studio-sim-host" value={host} onChange={(e) => onHost(e.target.value)} disabled={pending} />
      </Field>
      <Field invalid={port === null}>
        <Label htmlFor="studio-sim-port">Port block</Label>
        <Input id="studio-sim-port" value={basePort} inputMode="numeric" onChange={(e) => onBasePort(e.target.value)} disabled={pending} aria-invalid={port === null} />
        <FieldDescription>The devices listen on base + 5, 6 and 7 (`pnpm ports`).</FieldDescription>
      </Field>
    </div>
  );
}

export function VmixFields({ host, port, pending, onHost, onPort }: { readonly host: string; readonly port: string; readonly pending: boolean; readonly onHost: (v: string) => void; readonly onPort: (v: string) => void }) {
  const portValid = tcpPortOf(port) !== null;
  return (
    <div className="grid grid-cols-2 gap-3">
      <Field invalid={host.trim() === ''}>
        <Label htmlFor="studio-vmix-host">vMix host</Label>
        <Input id="studio-vmix-host" value={host} onChange={(e) => onHost(e.target.value)} disabled={pending} placeholder="192.168.1.20" aria-invalid={host.trim() === ''} />
        <FieldDescription>The Windows machine running vMix (docs/vmix.md).</FieldDescription>
      </Field>
      <Field invalid={!portValid}>
        <Label htmlFor="studio-vmix-port">TCP API port</Label>
        <Input id="studio-vmix-port" value={port} inputMode="numeric" onChange={(e) => onPort(e.target.value)} disabled={pending} aria-invalid={!portValid} />
        <FieldDescription>vMix's TCP API (Settings → Web Controller); {String(DEFAULT_VMIX_PORT)} unless moved.</FieldDescription>
      </Field>
    </div>
  );
}
